module.exports = __webpack_public_path__ + "static/indiegogo-250098ca9bc270b804712671f5ff5f8e.png";